/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_SubInputs */

const en_mk_ctrl_sub = /** @type {(inputs: Mk_Ctrl_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See agents, models, duration, attempts, and provider-reported tokens and costs. Bystep summarizes progress per feature, detects code drifting from the PRD, and assesses repository readiness for agents.`)
};

const id_mk_ctrl_sub = /** @type {(inputs: Mk_Ctrl_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat agent, model, durasi, percobaan, serta token dan biaya sesuai laporan provider. Bystep merangkum kemajuan per fitur, mendeteksi kode yang menyimpang dari PRD, dan menilai kesiapan repo untuk agent.`)
};

/**
* | output |
* | --- |
* | "See agents, models, duration, attempts, and provider-reported tokens and costs. Bystep summarizes progress per feature, detects code drifting from the PRD, a..." |
*
* @param {Mk_Ctrl_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_sub = /** @type {((inputs?: Mk_Ctrl_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_sub(inputs)
	return en_mk_ctrl_sub(inputs)
});